import React, { useEffect } from "react";
import "./Popup.css";
import { TileData } from "../components";
import { GradientButton } from "../../../components/Atomos/Buttons/GradientButton";
import { useNavigate } from "react-router-dom";
import { createPortal } from "react-dom";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  tileData?: TileData | null;
}

export default function Popup({ isOpen, onClose, tileData }: PopupProps) {
  useEffect(
    function closeOnEscape() {
      const handleEscape = (e: KeyboardEvent) => {
        if (e.key === "Escape") {
          onClose();
        }
      };
      window.addEventListener("keydown", handleEscape);
      return () => {
        window.removeEventListener("keydown", handleEscape);
      };
    },
    [onClose]
  );

  const navigate = useNavigate();

  if (!isOpen) {
    return null;
  }
  return createPortal(
    <div>
      <div className="popup-backdrop" onClick={onClose} />
      <div
        className="popup-modal md:w-[80vw] overflow-y-auto lg:overflow-y-hidden"
        tabIndex={-1}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            onClose();
          }
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="popup-close" onClick={onClose}>
          &#10005;
        </button>
        {tileData && (
          <div className="top-1/2 left-1/2 ">
            <div className="flex flex-col text-start mx-0 lg:m-10 ">
              <h4 className="text-secondary-dark text-3xl md:text-[2.5rem] lg:text-[3.5rem] leading-8 md:leading-[3rem] lg:leading-[4rem] py-4">
                {tileData.title}
              </h4>
              <div className="flex flex-col md:flex-row md:gap-6">
                <div className="h-full pb-4 md:pb-0 md:flex-1 flex items-start">
                  <span className="popup-tile-text !font-[300]">{tileData.fullText}</span>
                </div>
                <div className="md:w-1/2 md:max-w-[400px] md:flex-shrink-0 flex justify-center md:items-center">
                  <img
                    className="w-full h-auto object-contain"
                    src={tileData.image}
                    alt={tileData.title + " pop-up-image"}
                  />
                </div>
              </div>
              <div className="flex flex-row gap-2 py-4">
                {Array.from({ length: 3 }).map((_, index) => (
                  <div
                    key={index + "circle-dialog"}
                    className="w-6 h-6 bg-[#bc3323] rounded-full"
                  ></div>
                ))}
                <br />
                {tileData.actionButton && (
                  <GradientButton
                    text={tileData.actionButton.text}
                    onClick={() => {
                      if (tileData.actionButton?.onClick) {
                        tileData.actionButton.onClick();
                      }
                      if (tileData.actionButton?.navigateTo) {
                        window.scrollTo(0, 0);
                        navigate(tileData.actionButton.navigateTo);
                        onClose();
                      }
                    }}
                    rightIcon={tileData.actionButton.rightIcon}
                    className={
                      tileData.actionButton.className || "ml-auto mr-[6%]"
                    }
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  , document.body
  )
}
